import React from 'react';
import Button from '../../../../components/Button';
import { ProductItemProps } from '../../../../models/Product';
import { gtmEvent } from '../../../../utils/gtm';

type ActionButtonProps = {
  handleActionButton?: () => void;
  disable?: boolean;
};

export const ActionButton: React.FC<ActionButtonProps> = ({ handleActionButton, disable }) => {
  return <Button title="Continuar" disabled={disable} onClick={() => handleActionButton?.()} />;
};
